import { Sha2562y5o7gt1rnojl as Sha256 } from './internal/Sha256.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { checkOffsetAndCount2b5icqlx5z1pu as checkOffsetAndCount } from './Util.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  subtract2orl8z9upxd9l as subtract,
  fromInt2ii0rejb1w62w as fromInt,
  convertToInty04h231mmjoh as convertToInt,
  add2suhfggl4zvkk as add,
} from '../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { ByteString2qc03wzjsovk as ByteString } from './ByteString.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      g3x(sink) {
        return new (HashingSink())(sink, new (Sha256())());
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var HashingSinkClass;
function HashingSink() {
  if (HashingSinkClass === VOID) {
    class $ {
      constructor(sink, hashFunction) {
        this.h3x_1 = sink;
        this.i3x_1 = hashFunction;
      }
      j3s(source, byteCount) {
        checkOffsetAndCount(source.l3s_1, 0n, byteCount);
        var hashedCount = 0n;
        var s = ensureNotNull(source.k3s_1);
        while (hashedCount < byteCount) {
          var tmp0 = subtract(byteCount, hashedCount);
          // Inline function 'okio.minOf' call
          var b = s.c3t_1 - s.b3t_1 | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b_0 = fromInt(b);
          var tmp$ret$0 = tmp0 <= b_0 ? tmp0 : b_0;
          var toHash = convertToInt(tmp$ret$0);
          this.i3x_1.z3u(s.a3t_1, s.b3t_1, toHash);
          // Inline function 'kotlin.Long.plus' call
          var this_0 = hashedCount;
          hashedCount = add(this_0, fromInt(toHash));
          s = ensureNotNull(s.f3t_1);
        }
        this.h3x_1.j3s(source, byteCount);
      }
      oc() {
        return this.h3x_1.oc();
      }
      l6() {
        return this.h3x_1.l6();
      }
      j3x() {
        var result = this.i3x_1.a3v();
        return new (ByteString())(result);
      }
    }
    initMetadataForClass($, 'HashingSink');
    HashingSinkClass = $;
  }
  return HashingSinkClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Companion_instance as Companion_instance1ws7d9j63nohl,
};
//endregion

//# sourceMappingURL=HashingSink.mjs.map
